import { render, staticRenderFns } from "./packDialog.vue?vue&type=template&id=4792388d&scoped=true"
import script from "./packDialog.vue?vue&type=script&lang=js"
export * from "./packDialog.vue?vue&type=script&lang=js"
import style0 from "./packDialog.vue?vue&type=style&index=0&id=4792388d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4792388d",
  null
  
)

export default component.exports